module.exports = __webpack_public_path__ + "static/media/guest-list@2x.90c37248.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doodles/guest-list@2x.png
// module id = 2450
// module chunks = 71